module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"uk":{"defaultTitle":"Після проходження курсу ви зможете"},"en":{"defaultTitle":"After completing the course, you will be able to"}}')
  delete Component.options._Ctor
}
